"use client";

import NextError from "next/error";
import { useEffect } from "react";
import { captureException } from "@/lib/posthog";

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
}) {
  useEffect(() => {
    // Only log to console in development
    if (process.env.NODE_ENV !== "production") {
      console.error("[GlobalError]", error);
    }
    // Always send to PostHog for tracking
    captureException(error, {
      source: "GlobalError",
      digest: error.digest,
    });
  }, [error]);

  return (
    <html>
      <body>
        {/* `NextError` is the default Next.js error page component. Its type
        definition requires a `statusCode` prop. However, since the App Router
        does not expose status codes for errors, we simply pass 0 to render a
        generic error message. */}
        <NextError statusCode={0} />
      </body>
    </html>
  );
}
